import { Store } from '@stores/Store'
import { I18nKey } from '@utils/i18n'

export class LocalizationHelper {
  store!: Store

  constructor(store: Store) {
    this.store = store
  }

  // Localizations

  get 2024(): I18nKey {
    return 'INCOME_SIMULATOR_VERSION_2024'
  }

  get 2025(): I18nKey {
    return 'INCOME_SIMULATOR_VERSION_2025'
  }

  // Bronze Incentives

  get BRONZE_INCENTIVES_TOOLTIP(): I18nKey {
    const { store } = this
    const { versionHelper } = store
    const { version2024 } = versionHelper

    return version2024 ? 'BRONZE_INCENTIVES_TOOLTIP_2024' : 'BRONZE_INCENTIVES_TOOLTIP'
  }


  // Personal Group Growth Incentive

  get INFO_PERSONAL_GROUP_GROWTH_INCENTIVE_KEY(): I18nKey {
    const { selectedANZ } = this.store
    return selectedANZ ? 'INFO_PERSONAL_GROUP_GROWTH_INCENTIVE_ANZ' : 'INFO_PERSONAL_GROUP_GROWTH_INCENTIVE_EU'
  }


  // Performance Plus

  get PERFORMANCE_PLUS_GROUP_PV_REQUIREMENT_KEY(): I18nKey {
    const { selectedANZ } = this.store
    return selectedANZ ? 'PERFORMANCE_PLUS_GROUP_PV_REQUIREMENT_ANZ' : 'PERFORMANCE_PLUS_GROUP_PV_REQUIREMENT'
  }

  get PERFORMANCE_PLUS_GROUP_PV_LEG_REQUIREMENT_KEY(): I18nKey {
    const { selectedANZ } = this.store
    return selectedANZ ? 'PERFORMANCE_PLUS_GROUP_PV_LEG_REQUIREMENT_ANZ' : 'PERFORMANCE_PLUS_GROUP_PV_LEG_REQUIREMENT'
  }

  get INFO_PERFORMANCE_PLUS_KEY(): I18nKey {
    const { selectedANZ } = this.store
    return selectedANZ ? 'INFO_NEW_PERFORMANCE_PLUS_ANZ' : 'INFO_NEW_PERFORMANCE_PLUS_EU'
  }

  // Summary Core Plan Income
  get RUBY_BONUS_TOOLTIP(): I18nKey {
    const { selectedANZ } = this.store
    return selectedANZ ? 'RUBY_BONUS_TOOLTIP_ANZ' : 'RUBY_BONUS_TOOLTIP'
  }

}
